import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { LayoutService } from '../../core/layout/layout.service';
import { NavigationService } from '../../navigation/navigation.service';
import { FaIconComponent, faAnglesLeft } from '../../ui/icons/app-icons.registry';

/**
 * Role-filtered navigation projection (FR-002..FR-004). Non-permitted entries
 * are absent from the DOM via @for over visibleEntries() — never CSS-hidden
 * (Article XI-C). routerLinkActive's default non-exact matching keeps Clients
 * marked while /clients/:clientCode is active.
 *
 * US4 (FR-022/FR-023/FR-026): the collapse toggle renders only in the xl
 * band; md forces icon-only with the label exposed on hover and keyboard
 * focus; the persisted preference applies only at xl.
 */
@Component({
  selector: 'app-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, FaIconComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  private readonly navigation = inject(NavigationService);
  protected readonly layout = inject(LayoutService);

  protected readonly visibleEntries = this.navigation.visibleEntries;
  protected readonly collapseIcon = faAnglesLeft;

  protected toggleCollapse(): void {
    this.layout.setSidebarCollapsed(!this.layout.sidebarCollapsed());
  }
}
